import { savedOrderListHeaderStyles } from "@insite/content-library/Widgets/SavedOrderList/SavedOrderListHeader";

savedOrderListHeaderStyles.toggleFilterIcon = {
    src: "Filter",
    size: 24,
    color: "primary",
};
